import _forEach from "lodash/forEach"

const toLabelValues = (item) => {
  if (item.length === 3) {
    return { value: item[0], label: [item[1], item[2]] }
  }
  return { value: item[0], label: item[1] }
};

export default {
  namespaced: true,
  state: {
    message: null,
    consts: {},
    newsList: [],
    requestCount: 0,
    sideBarStatus: "hidden"
  },
  getters: {
    message (state) {
      return state.message;
    },
    news(state) {
      return state.newsList
    },
    consts (state) {
      return state.consts
    },
    isRequesting (state) {
      return state.requestCount > 0;
    },
    showSideBar (state) {
      return state.sideBarStatus === "show"
    },
    regions () {
      return [
        {
          label: '関東',
          value: 'kanto',
          prefectures: [
            {label: '東京', value: 13},
            {label: '神奈川', value: 14},
            {label: '埼玉', value: 11},
            {label: '千葉', value: 12},
            {label: '茨城', value: 8},
            {label: '栃木', value: 9},
            {label: '群馬', value: 10},
          ]
        },
        {
          label: '北海道・東北',
          value: 'hokkaidoTohoku',
          prefectures: [
            {label: '北海道', value: 1},
            {label: '青森', value: 2},
            {label: '岩手', value: 3},
            {label: '宮城', value: 4},
            {label: '秋田', value: 5},
            {label: '山形', value: 6},
            {label: '福島', value: 7},
          ]
        },
        {
          label: '信越・北陸',
          value: 'shinetuHokuriku',
          prefectures: [
            {label: '新潟', value: 15},
            {label: '富山', value: 16},
            {label: '石川', value: 17},
            {label: '福井', value: 18},
            {label: '山梨', value: 19},
            {label: '長野', value: 20},
          ]
        },
        {
          label: '東海',
          value: 'tokai',
          prefectures: [
            {label: '愛知', value: 23},
            {label: '岐阜', value: 21},
            {label: '静岡', value: 22},
            {label: '三重', value: 24},
          ]
        },
        {
          label: '近畿',
          value: 'kinki',
          prefectures: [
            {label: '大阪', value: 27},
            {label: '兵庫', value: 28},
            {label: '京都', value: 26},
            {label: '滋賀', value: 25},
            {label: '奈良', value: 29},
            {label: '和歌山', value: 30},
          ]
        },
        {
          label: '中国',
          value: 'chugoku',
          prefectures: [
            {label: '鳥取', value: 31},
            {label: '島根', value: 32},
            {label: '岡山', value: 33},
            {label: '広島', value: 34},
            {label: '山口', value: 35},
          ]
        },
        {
          label: '四国',
          value: 'shikoku',
          prefectures: [
            {label: '徳島', value: 36},
            {label: '香川', value: 37},
            {label: '愛媛', value: 38},
            {label: '高知', value: 39},
          ]
        },
        {
          label: '九州・沖縄',
          value: 'kyusyuOkinawa',
          prefectures: [
            {label: '福岡', value: 40},
            {label: '佐賀', value: 41},
            {label: '長崎', value: 42},
            {label: '熊本', value: 43},
            {label: '大分', value: 44},
            {label: '宮崎', value: 45},
            {label: '鹿児島', value: 46},
            {label: '沖縄', value: 47},
          ]
        },
        {
          label: 'その他',
          value: 'others',
          prefectures: [
            {label: '海外', value: 48},
          ]
        },

      ]
    }
  },
  mutations: {
    setMessage (state, payload) {
      state.message = payload.message;
    },
    setConsts (state, payload) {
      const consts = {};
      _forEach(payload.consts, (value, key) => {
        let constItems = []
        value.forEach((item) => {
          if (Array.isArray(item)) {
            constItems.push(toLabelValues(item))
          } else {
            constItems.push({ header: item.group || item.category})
            constItems = constItems.concat(
                item.items.map((groupItem) => toLabelValues(groupItem))
            )
          }
        })
        consts[key] = constItems
      });
      state.consts = consts;
    },
    setNews (state, payload) {
      state.newsList = payload.news
    },
    countUpRequest (state) {
      state.requestCount = state.requestCount + 1;
    },
    countDownRequest (state) {
      state.requestCount = state.requestCount - 1;
    },
    setSideBarStatus(state, {status}) {
      state.sideBarStatus = status
    }
  },
  actions: {
    showSuccess ({commit}, {message}) {
      commit("setMessage", {message: {label: message, type: "success"}});
    },
    showWarning ({commit}, {message}) {
      commit("setMessage", {message: {label: message, type: "warning"}});
    },
    showError ({commit}, {message}) {
      commit("setMessage", {message: {label: message, type: "error"}});
    },
    clearMessage ({commit}) {
      commit("setMessage", {message: null});
    },
    updateConsts ({commit}, {consts}) {
      commit("setConsts", {consts: consts})
    },
    updateNews ({commit}, {news}) {
      commit("setNews", {news: news})
    },
    beginRequest ({commit}) {
      commit("countUpRequest");
    },
    endRequest ({commit}) {
      commit("countDownRequest");
    },
    updateSideBarStatus({commit}, {status}) {
      commit("setSideBarStatus", {status: status})
    }
  }
}
